import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<number>('district_admins');

export function useDistrictAdminListQuery(districtId: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.districtsListDistrictAdminsList(districtId);
      return data;
    },
    queryKey: keys.list(districtId),
  });
}
